import * as React from "react";
import { Item, Segment } from "semantic-ui-react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { sortTasks } from "../crud/ohCase/model";
import { useAdminUserOptions } from "../crud/adminUser/useAdminUserOptions";

import { TaskWithActions } from "./taskWithActions";

interface Props {
    tasks: TaskModel[];
    customerId: string;
}

export const OhCaseTasksTimeline: React.FC<Props> = (props: Props) => {

    const adminUserOptions = useAdminUserOptions();

    if (!props.tasks.length) {
        return null;
    }

    return (
        <>
            <Segment attached raised>
                <Item.Group divided>
                    {props.tasks && sortTasks(props.tasks)
                        .map(task => <TaskWithActions task={task} key={task.id} customerId={props.customerId} adminUserOptions={adminUserOptions} />)}
                </Item.Group>
            </Segment>
        </>
    );
};
